var React = require('react');

function ArrowWithTail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.67681 6.24241C10.0952 5.88193 10.7266 5.92889 11.0871 6.34731C11.4476 6.76573 11.4006 7.39715 10.9822 7.75763L7.22007 10.9988L20 10.9988C20.5523 10.9988 21 11.4466 21 11.9988C21 12.5511 20.5523 12.9988 20 12.9988L7.2191 12.9988L10.9824 16.2426C11.4007 16.6031 11.4475 17.2346 11.087 17.6529C10.7264 18.0712 10.095 18.1181 9.67663 17.7575L3.87437 12.7563L2.99538 11.9987L3.87455 11.2412L9.67681 6.24241Z","fill":"currentColor"}));
}

ArrowWithTail.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowWithTail;

ArrowWithTail.default = ArrowWithTail;
